import _ from 'lodash';

import { USER_ROLE_ACTION_TYPE } from 'store/users/actions';

import {
  EDIT_MASTER_SUCCESS,
  MASTER_LOGGED_OUT_ACTION_TYPE,
  REMOVE_MASTER_DATA,
  SET_MASTER_DATA,
} from '../actions';

const initialState = {
  role: null, //guest
  company: {},
  data: {
    displayName: '',
    photoURL: '',
    email: '',
    shortcuts: [],
    impersonateMode: false,
  },
};

const master = (state = initialState, { type, payload, meta }) => {
  switch (type) {
    case SET_MASTER_DATA: {
      return {
        ...initialState,
        ...payload,
      };
    }

    case REMOVE_MASTER_DATA: {
      return {
        ...initialState,
      };
    }

    case MASTER_LOGGED_OUT_ACTION_TYPE: {
      return initialState;
    }

    case EDIT_MASTER_SUCCESS: {
      const { email, firstName, lastName, sex, settings } = payload;

      return {
        ...state,
        data: {
          ...state.data,
          email,
          firstName,
          lastName,
          displayName: `${firstName} ${lastName}`,
          sex,
          settings,
        },
      };
    }

    case USER_ROLE_ACTION_TYPE.SET_USER_ROLE:
      if (state.uuid === meta.userId && payload.name) {
        return {
          ...state,
          role: _.uniq(state.role.concat(payload.name)),
        };
      }

      return state;

    case USER_ROLE_ACTION_TYPE.DELETE_USER_ROLE:
      if (state.uuid === meta.userId && payload.name) {
        return {
          ...state,
          role: state.role.filter(role => role !== payload.name),
        };
      }

      return state;

    default: {
      return state;
    }
  }
};

export default master;
